<template>
  <b-tab :title="trans('reservation')" :disabled="disabled" lazy>
    <template v-slot:title>
      <i v-if="!!timer" class="fa fa-fw fa-shopping-cart"></i>
      <span v-if="!timer">{{ trans('shopping_cart') }}</span>
      <sup>
        <b-badge :variant="invoice.status == 'finalized' || !!timer && !timer.expired ? 'success' : 'danger'" pill v-if="itemCount > 0">
          {{ itemCount }}
        </b-badge>
      </sup>
      <span v-if="invoice.status != 'finalized' && !!timer" :class="`ml-2 ${timer.expired ? 'text-danger' : ''}`">
        {{ timer.text }}
      </span>
      <span v-if="invoice.status == 'finalized'" class="text-success">
        {{ trans(invoice.balance == 0 ? 'paid' : 'reserved') }}
      </span>
    </template>

    <b-card>
      <b-card-text v-if="!invoice || !invoice.finalized_at">
        <cart-content
          :organization="organization"
          :invoice="invoice"
          :button-title="buttonTitle"
          :hide-continue-shopping="hideContinueShopping"
          @invoice="$emit('invoice', $event)"
          @invoiceempty="$emit('invoiceempty', $event)"
          @close="$emit('close')"
          @click="$emit('click')"
          :show-close="showClose"
        ></cart-content>
        <div v-if="showAdminPayment">
          <br/>
          <admin-options
            variant="outline-danger"
            :organization="organization"
            :client-secret="client_secret"
            @client-secret="client_secret = $event"
            :invoice="invoice"
            @invoice="$emit('invoice', $event)"
          ></admin-options>
        </div>
      </b-card-text>
      <b-card-text v-if="!!invoice && !!invoice.finalized_at">
        <confirmation-card
          :organization="organization"
          :invoice="invoice"
          :recipient="invoice.recipient"
        ></confirmation-card>
      </b-card-text>
    </b-card>
  </b-tab>
</template>

<script>
  import CartContent from './CartContent'
  import AdminOptions from './CheckoutAdminOptions'
  import ConfirmationCard from './CheckoutConfirmation'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      showClose: {
        type: Boolean,
        default: false,
      },
      hideContinueShopping: {
        type: Boolean,
        default: false
      },
      buttonTitle: String,
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      CartContent,
      AdminOptions,
      ConfirmationCard,
    },
    data() {
      return {
        trans: trans,
        seconds: null,
        timerInterval: null,
        client_secret: null,
      }
    },
    computed: {
      itemCount() {
        return _.reduce(this.invoice.invoice_items, (count, item) => {
          if (!!item.package_id || !!item.product_id || !!item.membership_id || !!item.am_class_id) count += 1
          return count
        }, 0)
      },
      timer() {
        if (!this.invoice || !this.invoice.is_viable_cart) return null
        return _.buildCartTimer(this.seconds)
      },
      showAdminOptions() {
        return this.organization.auth_user &&
          this.organization.auth_user.microsite_permissions.has_admin_payments &&
          !!this.invoice.admin
      },
      showAdminPayment() {
        return this.invoice.total > 0 && this.invoice.is_no_client && this.invoice.status == 'new' && this.showAdminOptions
      },
    },
    watch: {
      invoice() {
        this.updateTimer()
      }
    },
    methods: {
      updateTimer() {
        this.seconds = this.invoice.status == 'expired' ? 0 : moment(this.invoice.expired_at).diff(moment(), 'seconds')
        if (this.seconds == 0 && this.timerInterval) {
          this.clearTimer()
        } else if (this.seconds > 0 && !this.timerInterval) {
          this.timerInterval = setInterval(this.updateTimer, 1000)
        }
      },
      clearTimer() {
        if (this.timerInterval) clearInterval(this.timerInterval)
        this.timerInterval = null
      },
    },
    mounted() {
      window.cartTab = this
      this.timerInterval = setInterval(this.updateTimer)
    },
    destroyed() {
      this.clearTimer()
    },
  }
</script>
